var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 16.625C15.5805 16.625 14.8258 17.5 12.25 17.5C9.67422 17.5 8.925 16.625 7.35 16.625C3.29219 16.625 0 19.9172 0 23.975V25.375C0 26.8242 1.17578 28 2.625 28H21.875C23.3242 28 24.5 26.8242 24.5 25.375V23.975C24.5 19.9172 21.2078 16.625 17.15 16.625ZM21.875 25.375H2.625V23.975C2.625 21.3719 4.74687 19.25 7.35 19.25C8.14844 19.25 9.44453 20.125 12.25 20.125C15.0773 20.125 16.3461 19.25 17.15 19.25C19.7531 19.25 21.875 21.3719 21.875 23.975V25.375ZM12.25 15.75C16.5977 15.75 20.125 12.2227 20.125 7.875C20.125 3.52734 16.5977 0 12.25 0C7.90234 0 4.375 3.52734 4.375 7.875C4.375 12.2227 7.90234 15.75 12.25 15.75ZM12.25 2.625C15.143 2.625 17.5 4.98203 17.5 7.875C17.5 10.768 15.143 13.125 12.25 13.125C9.35703 13.125 7 10.768 7 7.875C7 4.98203 9.35703 2.625 12.25 2.625Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.7990b3cbd7717eb52f061b0cdf96b8a2.svg";
export { ForwardRef as ReactComponent };